module.exports = __webpack_public_path__ + "img/s1-img2.9da7087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s1-img2.png
// module id = 402
// module chunks = 0